export const oklahoma = {
  "40000": "Oklahoma",
  "40001": "Adair County",
  "40003": "Alfalfa County",
  "40005": "Atoka County",
  "40007": "Beaver County",
  "40009": "Beckham County",
  "40011": "Blaine County",
  "40013": "Bryan County",
  "40015": "Caddo County",
  "40017": "Canadian County",
  "40019": "Carter County",
  "40021": "Cherokee County",
  "40023": "Choctaw County",
  "40025": "Cimarron County",
  "40027": "Cleveland County",
  "40029": "Coal County",
  "40031": "Comanche County",
  "40033": "Cotton County",
  "40035": "Craig County",
  "40037": "Creek County",
  "40039": "Custer County",
  "40041": "Delaware County",
  "40043": "Dewey County",
  "40045": "Ellis County",
  "40047": "Garfield County",
  "40049": "Garvin County",
  "40051": "Grady County",
  "40053": "Grant County",
  "40055": "Greer County",
  "40057": "Harmon County",
  "40059": "Harper County",
  "40061": "Haskell County",
  "40063": "Hughes County",
  "40065": "Jackson County",
  "40067": "Jefferson County",
  "40069": "Johnston County",
  "40071": "Kay County",
  "40073": "Kingfisher County",
  "40075": "Kiowa County",
  "40077": "Latimer County",
  "40079": "Le Flore County",
  "40081": "Lincoln County",
  "40083": "Logan County",
  "40085": "Love County",
  "40087": "McClain County",
  "40089": "McCurtain County",
  "40091": "McIntosh County",
  "40093": "Major County",
  "40095": "Marshall County",
  "40097": "Mayes County",
  "40099": "Murray County",
  "40101": "Muskogee County",
  "40103": "Noble County",
  "40105": "Nowata County",
  "40107": "Okfuskee County",
  "40109": "Oklahoma County",
  "40111": "Okmulgee County",
  "40113": "Osage County",
  "40115": "Ottawa County",
  "40117": "Pawnee County",
  "40119": "Payne County",
  "40121": "Pittsburg County",
  "40123": "Pontotoc County",
  "40125": "Pottawatomie County",
  "40127": "Pushmataha County",
  "40129": "Roger Mills County",
  "40131": "Rogers County",
  "40133": "Seminole County",
  "40135": "Sequoyah County",
  "40137": "Stephens County",
  "40139": "Texas County",
  "40141": "Tillman County",
  "40143": "Tulsa County",
  "40145": "Wagoner County",
  "40147": "Washington County",
  "40149": "Washita County",
  "40151": "Woods County",
  "40153": "Woodward County",
};
